import { createSlice } from "@reduxjs/toolkit";

const todaySandhayaSlice = createSlice({
  name: "todaySandhayaAdd",
  initialState: {
    isTodaySandhayaAddOpen: false,
  },
  reducers: {
    toogleTodaySandhayaAdd: (state) => {
      state.isTodaySandhayaAddOpen = !state.isTodaySandhayaAddOpen;
    },
  },
});

export const { toogleTodaySandhayaAdd } = todaySandhayaSlice.actions;
export default todaySandhayaSlice.reducer;